import React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Add User ",
  },
];

const validationSchema = yup.object({
  username: yup
    .string("Enter User Name")
    .matches(
      /^[a-z]+$/,
      "User Name should only contain small Alphabet without space"
    )
    .min(2, "User Name should be of minimum 2 characters in length")
    .max(30, "User Name should be of maximum 30 characters in length")
    .required("User Name is required"),

    thana_name: yup
    .string("Enter police station Name")
    .matches(
      /^[a-zA-Z0-9-,. ]+$/,
      "police station Name should only contain Alphabet and Number"
    )
    .min(2, "police station Name should be of minimum 2 characters in length")
    .max(30, "police station Name should be of maximum 30 characters in length")
    .required("police station Name is required"),

  contact: yup
    .string("Enter Contact No")
    .matches(/^[0-9]+$/, "Contact No should only contain digits")
    .min(10, "Contact number should be at least 10 digits long")
    .max(10, "Contact number should not exceed 10 digits")
    .required("Contact no is Required"),
    email_id: yup
    .string("Enter Email Id")
    .required("Email Id  is Required"),
});

const AddThanaUser = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const initialValues = {
    district_id: sessionData.data.district_id,
    username: "",
    contact: "",
    email_id: "",
    thana_name: "",
    c_by: sessionData.data.id,
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log("check values----", values);
      try {
        const res = await UserService.addThanaUser(values);
        swal("success", res.message, "success");
        setTimeout(() => {
          navigate("/thanauserlist");
        }, 1000);
      } catch (error) {
        swal("error", error, "error");
      }
    },
  });

  return (
    <>
      <Breadcrumb title="Add User List" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add User List
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/thanauserlist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="username">
                User Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="username"
                name="username"
                type="text"
                value={formik.values.username}
                onChange={(e) => {
                  const value = e.target.value.toLowerCase().replace(/\s/g, "");
                  formik.setFieldValue("username", value);
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.username && Boolean(formik.errors.username)
                }
                helperText={formik.touched.username && formik.errors.username}
                variant="outlined"
                placeholder="Enter username"
                fullWidth
              />
            </Grid>
            {/* ==== Contact no ===  */}
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="contact">
                Contact No
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="contact"
                name="contact"
                type="text"
                value={formik.values.contact}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.contact && Boolean(formik.errors.contact)}
                helperText={formik.touched.contact && formik.errors.contact}
                variant="outlined"
                placeholder="Enter Contact no"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="email_id">
                Email Id <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="email_id"
                name="email_id"
                type="email"
                value={formik.values.email_id}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.email_id && Boolean(formik.errors.email_id)
                }
                helperText={formik.touched.email_id && formik.errors.email_id}
                variant="outlined"
                placeholder="Enter email id"
                fullWidth
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="thana_name">
                Police Station Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="thana_name"
                name="thana_name"
                type="text"
                value={formik.values.thana_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.thana_name && Boolean(formik.errors.thana_name)
                }
                helperText={
                  formik.touched.thana_name && formik.errors.thana_name
                }
                variant="outlined"
                placeholder="Enter Police Station Name"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default AddThanaUser;
